"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../Colors");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const common_1 = require("../../common");
const RegistButtonStyled = styled_components_1.default.div `
	.button {
		width: 48px;
		height: 48px;
	}
`;
exports.RegistButton = react_1.default.memo(({ handlerButtonClick }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const isIpad = (() => {
        const ua = navigator.userAgent;
        return /iPad/.test(ua) || (ua.includes('Macintosh') && 'ontouchend' in document);
    })();
    return (react_1.default.createElement(RegistButtonStyled, { "$isMobile": isMobile, "$isTablet": isTablet },
        react_1.default.createElement(common_1.Button, { className: "btn_pink round", option: {
                buttonBeforeIcon: {
                    show: true,
                    name: 'penEdit',
                    size: 18,
                    color: Colors_1.Colors.white,
                },
            }, styles: {
                buttonWrap: {
                    position: 'fixed',
                    bottom: isIpad ? "unset" : isDesktop ? 55 : 139,
                    top: isIpad ? window.innerHeight - 179 : 'unset',
                    right: isMobile ? 26 : isTablet ? 46 : 62,
                    width: 48,
                    height: 48,
                    touchAction: 'none',
                },
            }, onClick: handlerButtonClick })));
});
